import React, {Component} from 'react'
import './styles.scss';

class RoundButton extends Component {
    render() {
        let className = "RoundButton";
        if (this.props.default) className += " default";
        if (this.props.shadow) className += " RoundButton--shadow";
        if (this.props.border) className += " RoundButton--border";
        if (this.props.size) className += " size--" + this.props.size;

        let title = "";
        if (this.props.label) title = this.props.label;

        return (<a className={className} onClick={this.props.onClick} title={title}>
            {this.props.icon}
        </a>);
    }
}

export default RoundButton;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/RoundButton/index.js